import asArray from '../arrays/asArray.util';

const categoryExists = ({ categories, category }) => !!asArray(categories).find(({ id, name }) => name === category.name && (!category.id || category.id !== id));

// noinspection JSUnusedGlobalSymbols
export default categoryExists;
